<template>
    <ClientOnly>
        <Dialog unstyled v-model:visible="visible" position="bottom" :style="{ width: '100%', bottom: '10%' }"
            class="z-30">
            <template #container>
                <div
                    class="fixed bottom-5 left-1/2 transform -translate-x-1/2 bg-[#2c3043] text-white p-4 rounded-lg shadow-lg max-w-screen-sm w-full flex max-sm:flex-col max-sm:items-start items-center justify-between sm:space-x-4 max-sm:space-y-2">
                    <div>
                        <p class="font-semibold">Accept Privacy Policy</p>
                        <p class="text-sm">
                            We use cookies to personalize your experience. By continuing to
                            visit this website you agree to our use of cookies.
                            <NuxtLink to="/privacy-policy" class="underline hover:no-underline">
                                Privacy Policy
                            </NuxtLink>
                        </p>
                    </div>
                    <button @click="closeModalAndSaveCookie"
                        class="bg-white text-[#2c3043] font-semibold px-4 sm:px-6 py-2 rounded hover:bg-gray-100">
                        Accept
                    </button>
                </div>
            </template>
        </Dialog>
    </ClientOnly>
</template>

<script setup>
import { ref, onMounted } from "vue";

const visible = ref(false);

const closeModalAndSaveCookie = () => {
    visible.value = false;
    localStorage.setItem("cookieConsent", "allowed");
};

onMounted(() => {
    setInterval(() => {
        if (localStorage.getItem("cookieConsent") !== "allowed") {
            visible.value = true;
        }
    }, 5000);
});
</script>
